import { useSelectedChain } from "@app/examples/ChainSelector";
import { LCDClient, LCDClientConfig } from "@terra-money/terra.js";
import { useEffect, useState } from "react";
import { useChains } from "./ChainsHook";

export function useLCD(chainId?: string) {
    const [lcd, setLCD] = useState<LCDClient>()
    const chains = useChains()
    const { selectedChain } = useSelectedChain()

    useEffect(() => {
        let config: (LCDClientConfig & { tax?: number }) | undefined = undefined;
        if (chainId != undefined && chains.length > 0) {
            const chain = chains.find(e => e.chainId == chainId)!
            config = {
                gasAdjustment: chain.gasAdjustment ?? 1,
                isClassic: chain.isClassic,
                chainID: chainId,
                URL: chain.lcdUrl,
                gasPrices: JSON.parse(chain.gasPrices ?? "[]"),
                tax: chain.tax
            }
        } else if (selectedChain) {
            config = {
                gasAdjustment: selectedChain.gasAdjustment ?? 1,
                isClassic: selectedChain.isClassic,
                chainID: selectedChain.chainId,
                URL: selectedChain.lcdUrl,
                gasPrices: JSON.parse(selectedChain.gasPrices ?? "[]"),
                tax: selectedChain.tax
            }
        }

        if (config) setLCD(new LCDClient(config))

    }, [selectedChain, chains])

    return lcd
}